const DISCLAIMER_SECTION = /<section class="lp-disclaimer-wrap"[\s\S]*?<\/section>/i;

export function separateLandingPageDisclaimer(html: string) {
  const match = html.match(DISCLAIMER_SECTION);

  return {
    contentHtml: match ? html.replace(match[0], "") : html,
    disclaimerHtml: match?.[0] ?? "",
  };
}